import React from 'react';
import { APIProvider } from '@vis.gl/react-google-maps';
import constants from '~/utils/constants';
import { getSupportedLanguage, getRegion } from '~/utils/localization-utils';
import { onGoogleMapsApiLoad, onGoogleMapsApiError } from './googleMapsApi';
import type { GoogleMapsApiProviderProps } from './types';

// stable reference, `APIProvider` re-serializes its params when this changes
const libraries = Object.values(constants.mapLibraries);

/**
 * Loads the Google Maps JavaScript API once for the whole app
 *
 * @see {@link https://visgl.github.io/react-google-maps/docs/api-reference/components/api-provider}
 * @see {@link https://developers.google.com/maps/faq#languagesupport}
 * @see {@link https://developers.google.com/maps/documentation/javascript/localization#Region}
 */
const GoogleMapsApiProvider = ({ children }: GoogleMapsApiProviderProps) => {
    return (
        <APIProvider
            apiKey={constants.mapOptionSettings.DEFAULT_GOOGLE_MAP_KEY}
            libraries={libraries}
            version={constants.mapOptionSettings.VERSION}
            language={getSupportedLanguage()}
            region={getRegion()}
            onLoad={onGoogleMapsApiLoad}
            onError={onGoogleMapsApiError}
        >
            {children}
        </APIProvider>
    );
};

export { GoogleMapsApiProvider };
